// src/views/pages/restaurant-reservations/waitlist/utils.js
import { Tag } from "antd";
import moment from "moment";

/**
 * Premium pill helper (consistent tokens)
 */
export const pill = (color, text, icon = null) => (
  <Tag
    color={color}
    style={{
      borderRadius: 999,
      fontWeight: 900,
      padding: "2px 10px",
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      lineHeight: 1.25,
      userSelect: "none",
    }}
  >
    {icon}
    {text || "—"}
  </Tag>
);

/**
 * Table status -> pill (normalized + safe)
 */
export const tableStatusPill = (status) => {
  const s = String(status || "").trim().toLowerCase();

  if (s === "available") return pill("green", "Available");
  if (s === "occupied") return pill("red", "Occupied");
  if (s === "cleaning") return pill("orange", "Cleaning");
  if (!s) return pill("default", "Unknown");

  // fallback: show raw
  return pill("default", s.charAt(0).toUpperCase() + s.slice(1));
};

/**
 * Actual wait minutes (safe if joinTime missing/invalid)
 */
export const calcActualWaitMin = (joinTime) => {
  if (!joinTime) return 0;

  const m = moment(joinTime);
  if (!m.isValid()) return 0;

  return Math.max(moment().diff(m, "minutes"), 0);
};

/**
 * Lightweight ETA estimation (guarded inputs)
 */
export const estimateWaitAI = ({ partySize, isWeekend, occupancyPct }) => {
  const ps = Math.max(Number(partySize || 2), 1);
  const occ = Math.min(Math.max(Number(occupancyPct || 0), 0), 100);

  const base = 6 + Math.floor(ps * 2.2);
  const weekendBoost = isWeekend ? 1.2 : 1.0;
  const occBoost = 1 + Math.min(Math.max((occ - 45) / 100, 0), 0.8);

  return Math.max(5, Math.round(base * weekendBoost * occBoost));
};
